import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { checkEnabledFeature, getKeyFeaturesConfig } from 'utils/function';
import { useUserData } from './useUserData';

type Option = {
  type?: 'permission' | 'generalConfig';
  keys: string[];
};

export const usePermission = (option: Option) => {
  const { type = 'permission', keys } = option;
  const isPermissionType = type === 'permission';

  const configReducer = useSelector((state: RootState) => state.configReducer);
  const { isLoadingConfig, permission, generalConfig } = configReducer;
  const loadingGeneralConfig = Object.keys(generalConfig).length === 0;

  const userData = useUserData();

  const getPermission = (keys: string[]) => {
    const [firstKey, ...otherKeys] = keys;

    let isEnabled = permission?.[firstKey]?.enabled;
    let features = permission?.[firstKey]?.features || [];

    if (!isEnabled) return isEnabled;

    for (let i = 0; i < otherKeys.length; i++) {
      const config = getKeyFeaturesConfig(features, otherKeys[i]);
      isEnabled = checkEnabledFeature(config);
      if (!isEnabled) return isEnabled;
      features = config?.features;
    }

    return isEnabled;
  };

  const enabled = isPermissionType ? getPermission(keys) : get(generalConfig, keys);
  const loading = isPermissionType ? isLoadingConfig : loadingGeneralConfig;

  return {
    enabled,
    loading: !userData || loading,
  };
};
